import { FilterButton, Menu, MenuDropdown, MenuOptionList, MenuOption} from "@launchmetrics/lm-ui";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";

function GenericDropdownMenu(props) {
	const {field, menuName, options = [], selectedOption, onChange, valueToLabel, onSearchChange} = props;
	const [selectedValues, setSelectedValues] = useState(selectedOption ? selectedOption.split(',').map(item => item.trim()) : []);
	const [displayValues, setDisplayValues] = useState(options.map(option => option.value));
	const [searchInputValue, setSearchInputValue] = useState();

	const optionValuesKey = JSON.stringify(options.map(option => option.value));

	useEffect(() => {
		const newValues = selectedOption ? selectedOption.split(',').map(item => item.trim()).filter(Boolean) : [];
		setSelectedValues(newValues);
	}, [selectedOption]);

	useEffect(() => {
		setDisplayValues(JSON.parse(optionValuesKey));
	}, [optionValuesKey]);

	useEffect(() => {
		if (searchInputValue === null) { setSearchInputValue('');}
	}, [searchInputValue]);

	const inputSearchHandler = (value) => {
		if (onSearchChange) {
			onSearchChange(value || '');
			return;
		}
		if (!value) setDisplayValues(options.map(option => option.value));
		else setDisplayValues([...options.filter(option => option.label.toLowerCase().includes(value.toLowerCase())).map(option => option.value)]);
	};

	const selectionChange = (values) => {
		setSelectedValues(values);
		onChange(field, values);
	};

	const onClose = () => {
		setSearchInputValue(null);
		inputSearchHandler(null);
	}

	const filterLabel = selectedValues.length === 0
		? `${menuName} · All`
		: menuName;

	return <>
		<Menu
			name={menuName}
			displayedValues={displayValues}
			onChange={selectionChange}
			searchInputValue={searchInputValue}
			onSearchInputChange={inputSearchHandler}
			searchable
			selectedValues={selectedValues}
			{...(valueToLabel && { renderValue: (v) => valueToLabel[v] || v })}
			>
			<FilterButton onClose={onClose} filterName={filterLabel} type="button"/>
			<MenuDropdown onClear={onClose}>
				<MenuOptionList>
					{options.map(option => (
						<MenuOption key={option.value} value={option.value}>{option.label}</MenuOption>
					))}
				</MenuOptionList>
			</MenuDropdown>
		</Menu>
	</>
}

GenericDropdownMenu.propTypes = {
	field: PropTypes.string.isRequired,
	menuName: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		})
	).isRequired,
	onChange: PropTypes.func.isRequired,
	selectedOption: PropTypes.string,
	onSearchChange: PropTypes.func,
};

export default GenericDropdownMenu;
